import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="w-full bg-[#eef4ff] px-4 py-16 sm:py-20" data-id="element-282" data-mp="3mgaf6jdmfgpb">
      <div className="mx-auto max-w-5xl" data-id="element-283" data-mp="3mepnd1ioybv5">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-ink sm:text-4xl" data-id="element-284" data-mp="3r7sfr6bqff9r">What Other Dental Professionals Are Saying</h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-slate-600" data-id="element-285" data-mp="3akyodfawpw">An educational framework designed around practical restorative questions.</p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-286" data-mp="937d4zz0udpp">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_4px_20px_rgba(8,23,51,0.08)]" data-id="element-287" data-mp="dzo03quhim17">
              <div className="flex items-center justify-between" data-id="element-288" data-mp="2av3l5zlzd5fq">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-289" data-mp="2fteu884gbbww">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-cta text-cta" aria-hidden data-id="element-290" data-mp="1smm3hmsrk52c" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-8 w-8 text-brand/40" aria-hidden data-id="element-291" data-mp="1iug9y8mv5fl1" />
              </div>
              <blockquote className="mt-4 flex-1 text-[16px] leading-relaxed text-slate-800" data-id="element-292" data-mp="1etecnxcibdlp">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-slate-100 pt-5" data-id="element-293" data-mp="2bjn999u5697c">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand/30" loading="lazy" data-id="element-294" data-mp="26k29ix75dwtk" />
                <div data-id="element-295" data-mp="22gvxta19ndfp">
                  <p className="font-display text-base font-black text-ink" data-id="element-296" data-mp="1xjm9xytiz9tz">{t.name}</p>
                  <p className="text-sm text-slate-600" data-id="element-297" data-mp="1xlyos33zl42t">{t.role} · {t.location}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-298" data-mp="m2w0m6tt21w5">
          <CTAButton label="I want the same clarity in my planning" data-id="element-299" data-mp="nlmj60xuqrot" />
        </div>
      </div>
    </section>;
}